import React from 'react';
import { Card, CardBody, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { Hometxt, Messages, Modalcontent, Modalsmallpara, Profile, Settings, TabsVertical } from '../../../../../../Constant';
import { P } from '../../../../../../AbstractElements';
import HeaderCard from '../../../../../Common/HeaderCard';
import TabsPreventDefaultAndAnimation from '../../../../../../Hoc/TabsPreventDefaultAndAnimation';

const Vertical = ({ show, tabActive, tabActiveHandler }) => {
  return (
    <Col sm='12' xl='6 xl-100 box-col-12'>
      <Card>
        <HeaderCard title={TabsVertical} />
        <CardBody>
          <Row>
            <Col sm='3' xs='12'>
              <Nav className='nav flex-column nav-pills nav-primary'>
                <NavItem>
                  <NavLink href='#javascript' className={tabActive === '1' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '1')}>
                    {Hometxt}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href='#javascript' className={tabActive === '2' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '2')}>
                    {Profile}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href='#javascript' className={tabActive === '3' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '3')}>
                    {Messages}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href='#javascript' className={tabActive === '4' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '4')}>
                    {Settings}
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col sm='9' xs='12'>
              <TabContent activeTab={tabActive}>
                <TabPane className={`fade ${tabActive === '1' ? show : ''}`} tabId='1'>
                  <P>
                    {Modalcontent}
                    {Modalsmallpara}
                  </P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '2' ? show : ''}`} tabId='2'>
                  <P>{Modalcontent}</P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '3' ? show : ''}`} tabId='3'>
                  <P>{Modalcontent}</P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '4' ? show : ''}`} tabId='4'>
                  <P>{Modalcontent}</P>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabsPreventDefaultAndAnimation(Vertical);
